import React from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";

const TableProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  formColumn,
  tableColumns,
  setTableColumns,
  updateTableProperties,
}) => {
  const handleCheckboxChange = (checked, column) => {
    setTableColumns((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[column.columnName] = true;
      } else {
        delete updated[column.columnName];
      }
      return updated;
    });
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      const newSelected = {};
      formColumn.forEach((col) => {
        newSelected[col.columnName] = true;
      });
      setTableColumns(newSelected);
    } else {
      setTableColumns({});
    }
  };

  const isChecked = (columnName) => !tableColumns[columnName];
  const allSelected =
    formColumn.length > 0 &&
    formColumn.every((col) => !tableColumns[col.columnName]);

  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  <Form.Check
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) =>
                      handleSelectAllChange(allSelected ? true : false)
                    }
                  />
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Column Label</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Column Name</th>
                <th
                  style={{ width: 100 }}
                  onMouseDown={(e) => onMouseDown(e, 3)}
                >
                  Column Type
                </th>
              </tr>
            </thead>
            <tbody>
              {formColumn?.map((item, index) => (
                <tr key={`dynamic-${index}`}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={isChecked(item.columnName)}
                      onChange={(e) =>
                        handleCheckboxChange(
                          isChecked(item.columnName) ? true : false,
                          item
                        )
                      }
                    />
                  </td>
                  <td>{item?.columnLabel}</td>
                  <td>{item?.columnName}</td>
                  <td>{item?.columnType}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            onClick={updateTableProperties}
            className="updateProfile"
            style={{ fontSize: 13 }}
          >
            Apply
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default TableProperties;
